import { render } from "./AddPrinterComponent.vue?vue&type=template&id=1443abe4"
import script from "./AddPrinterComponent.vue?vue&type=script&lang=js"
export * from "./AddPrinterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__